module.exports = __webpack_public_path__ + "img/gsjjt.48bf15a2.png";